function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icon/image/looks_5_24px");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M19,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z M19,11.3333333 C19,12.4666667 18.09,13.3333333 16.9,13.3333333 L14.1,13.3333333 L14.1,16 L12,16 L12,8 L16.9,8 C18.09,8 19,8.86666667 19,10 L19,11.3333333 Z M14,10 L17,10 L17,11 L14,11 L14,10 Z M9,16 L7,16 L5,16 L5,14 L9,14 L9,13 L6,13 C5.45,13 5,12.55 5,12 L5,9 C5,8.45 5.45,8 6,8 L7,8 L9,8 L11,8 L11,10 L7,10 L7,11 L10,11 C10.55,11 11,11.45 11,12 L11,15 C11,15.55 10.55,16 10,16 L9,16 Z",
  id: "path-1"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "icon/image/looks_5_24px",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("g", {
  fillRule: "nonzero"
}), React.createElement("g", {
  id: "Grayscale/Black",
  mask: "url(#mask-2)",
  fill: "rgba(0, 0, 0, 0.38)"
}, React.createElement("rect", {
  x: 0,
  y: 0,
  width: 24,
  height: 24
})));

var SvgDmarcSpIcon = function SvgDmarcSpIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDmarcSpIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dmarc-sp-icon.120d6518.svg";
export { ForwardRef as ReactComponent };